import { QueryClientProvider } from '@tanstack/react-query';
import { Fragment, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router/dom';
import { useMe } from '@/features/auth/api';
import { NotionImportHost } from '@/features/docs/NotionImportHost';
import { setLang, useLang } from '@/shared/i18n';
import { OfflineBoot } from '@/shared/offline/OfflineBoot';
import { Toaster } from '@/shared/ui/Toast';
import { Tooltips } from '@/shared/ui/Tooltips';
import { makeQueryClient } from './queryClient';
import { RootErrorBoundary } from './RootErrorBoundary';
import { createRouter } from './router';

/** Язык из настроек профиля (на сервере) — одинаковый на всех устройствах человека. */
function LanguageSync() {
  const me = useMe();
  const language = me.data?.user.preferences.language;
  useEffect(() => {
    if (language !== undefined) setLang(language);
  }, [language]);
  return null;
}

export function App() {
  const [client] = useState(makeQueryClient);
  const [router] = useState(createRouter);
  // Сменился язык — перерисовываем весь интерфейс; адрес и загруженные данные остаются.
  const lang = useLang();
  return (
    <RootErrorBoundary>
      <QueryClientProvider client={client}>
        <OfflineBoot>
          <LanguageSync />
          <Fragment key={lang}>
            <RouterProvider router={router} />
            <NotionImportHost />
            <Toaster />
            <Tooltips />
          </Fragment>
        </OfflineBoot>
      </QueryClientProvider>
    </RootErrorBoundary>
  );
}
